
import { computed, defineComponent, watch, ref, nextTick, toRef } from '@nuxtjs/composition-api';
import { toNumber } from '@/utils/helpers';

import clsx from 'clsx'

// type PageItem = number | 'jump-prev' | 'jump-next';
interface PageItem {
  type: 'number' | 'jump-prev' | 'jump-next';
  page: number
}
function calculatePage(p: number | undefined, pageSize: number, total: number) {
  const _pageSize = typeof p === 'undefined' ? pageSize : p;
  return Math.floor((total - 1) / _pageSize) + 1;
}
export default defineComponent({
  name: 'VPagination',
  props: {
    total: {
      type: Number,
      default: 0
    },

    pageSize: {
      type: Number,
      default: 10
    },
    layout: {
      type: String,
      default: 'prev, pager, next, jumper, ->, total, slot'
    },
    page: {
      type: Number,
      default: 1
    },
    pagerCount: {
      type: Number,
      default: 7
    },
    max: {
      type: Number,
      default: 7
    },
    divider: {
      type: String,
      default: '…'
    },
  },
  emits: ['current-change', 'update:page', 'size-change', 'prev-click', 'next-click'],
  setup(props, {
    emit
  }) {

    const currentPage = computed({
      get() {
        return props.page
      },
      set(val) {
        emit('update:page', val)
      }
    })
    const pages = computed(() => Array.from({ length: Math.ceil(props.total / props.pageSize) }, (_, i) => i + 1))

    const canGoFirstOrPrev = computed(() => currentPage.value > 1)
    const canGoLastOrNext = computed(() => currentPage.value < pages.value.length)


    const displayedPages = computed(() => {
      const totalPages = Math.ceil(props.total / props.pageSize);
      const current = props.page;
      const maxDisplayedPages = Math.max(props.max, 5)
      const jumpPrevPage = Math.max(1, currentPage.value - props.max);
      const jumpNextPage = currentPage.value = Math.min(calculatePage(undefined, props.pageSize, props.total), currentPage.value + props.max);

      const r = Math.floor((Math.min(maxDisplayedPages, totalPages) - 5) / 2)
      const r1 = current - r
      const r2 = current + r

      const beforeWrapped = r1 - 1 > 1
      const afterWrapped = r2 + 1 < totalPages

      const items: Array<PageItem> = [];

      if (totalPages <= maxDisplayedPages) {
        for (let i = 1; i <= totalPages; i++) {
          items.push({
            type: 'number',
            page: i
          })
        }
        return items;
      }
      items.push({
        type: 'number',
        page: 1
      });

      if (beforeWrapped) {
        items.push({
          type: 'jump-prev',
          page: jumpPrevPage
        })
      }
      if (!afterWrapped) {
        const addedItems = (current + r + 2) - totalPages
        for (let i = current - r - addedItems; i <= current - r - 1; i++) {
          items.push({
            type: 'number',
            page: i
          })
        }
      }

      for (let i = Math.max(2, r1); i <= Math.min(totalPages, r2); i++) {
        items.push({
          type: 'number',
          page: i
        })
      }

      if (!beforeWrapped) {
        const addedItems = 1 - (current - r - 2)
        for (let i = current + r + 1; i <= current + r + addedItems; i++) {
          items.push({
            type: 'number',
            page: i
          })
        }
      }
      if (afterWrapped) items.push({
        type: 'jump-next',
        page: jumpNextPage
      })

      if (r2 < totalPages) {
        items.push({
          type: 'number',
          page: totalPages
        })
      }

      // Replace divider by number on start edge case [1, '…', 3, ...]
      if (items.length >= 3 && items[1].type !== 'number' && items[2].page === 3) {
        items[1].page = 2
      }

      // Replace divider by number on end edge case [..., 48, '…', 50]
      if (items.length >= 3 && items[items.length - 2].type !== 'number' && items[items.length - 1].page === items.length) {
        items[items.length - 2].page = items.length - 1
      }
      return items
    })

    const onClickPage = (page: PageItem) => {
      // let newPage = page;
      currentPage.value = page.page;
      props.page !== page.page && emit('current-change', page.page);
    }
    // const pagerCount = 7;

    // const { page } = toRefs(props);
    // const {
    //   currentPage,
    //   currentPageSize,
    //   pageCount,
    //   isFirstPage,
    //   isLastPage,
    //   prev,
    //   next
    // } = useOffsetPagination({
    //   total: toRef(props, 'total'),
    //   page: props.page,
    //   pageSize: props.pageSize,
    //   onPageChange(page) {
    //     nextTick(() => {
    //       if (props.page != currentPage.value) {
    //         emit('update:page', page.currentPage)
    //         emit('current-change', page.currentPage)
    //       }
    //     })
    //   },
    //   onPageSizeChange({ currentPageSize }) {
    //     emit('size-change', currentPageSize)
    //   }
    // })

    watch(() => props.page, (value) => {
      currentPage.value = value;
    })

    const onClickPrev = () => {
      if (!canGoFirstOrPrev.value) {
        return
      }
      //currentPage.value--
      emit('current-change', --currentPage.value);
    }

    const onClickNext = () => {
      if (!canGoLastOrNext.value) {
        return
      }
      //currentPage.value++
      emit('current-change', ++currentPage.value);
    }

    // const onQuickPrev = () => {
    //   const pagerCountOffset = props.pagerCount - 2;
    //   currentPage.value -= pagerCountOffset
    // }

    // const onQuickNext = () => {
    //   const pagerCountOffset = props.pagerCount - 2;
    //   currentPage.value += pagerCountOffset
    // }

    // ======================= view pager state =======================
    // const pagerState = computed(() => {

    //   const halfPagerCount = (props.pagerCount - 1) / 2;

    //   let showPrevMore = false;
    //   let showNextMore = false;

    //   if (pageCount.value > props.pagerCount) {
    //     if (currentPage.value > props.pagerCount - halfPagerCount) {
    //       showPrevMore = true;
    //     }

    //     if (currentPage.value < pageCount.value - halfPagerCount) {
    //       showNextMore = true;
    //     }
    //   }

    //   const array = []

    //   if (showPrevMore && !showNextMore) {
    //     const startPage = pageCount.value - (props.pagerCount - 2);
    //     for (let i = startPage; i < pageCount.value; i++) {
    //       array.push(i);
    //     }
    //   } else if (!showPrevMore && showNextMore) {
    //     for (let i = 2; i < props.pagerCount; i++) {
    //       array.push(i);
    //     }
    //   } else if (showPrevMore && showNextMore) {
    //     const offset = Math.floor(props.pagerCount / 2) - 1;
    //     for (let i = currentPage.value - offset; i <= currentPage.value + offset; i++) {
    //       array.push(i);
    //     }
    //   } else {
    //     for (let i = 2; i < pageCount.value; i++) {
    //       array.push(i);
    //     }
    //   }


    //   return {
    //     pagers: array,
    //     showPrevMore,
    //     showNextMore
    //   }
    // })


    // ======================= jump =======================
    const userInput = ref<string | number>(currentPage.value);
    watch(currentPage, (value) => {
      userInput.value = value
    }, {
      immediate: true
    })

    const onJumpChange = () => {
      nextTick(() => {
        const newPage = currentPage.value = Number.isNaN(toNumber(userInput.value)) ? 1 : toNumber(userInput.value);
        emit('current-change', newPage);
      })
    }


    const coms = computed(() => {
      return props.layout.split(',').map((item) => {
        return item.trim()
      })
    })

    return {
      displayedPages,
      onClickPage,
      // pagerState,

      currentPage,

      canGoFirstOrPrev,
      canGoLastOrNext,

      // currentPageSize,
      // pageCount,
      // isFirstPage,
      // isLastPage,

      // onPrev,
      // onNext,

      onClickPrev,
      onClickNext,

      userInput,
      onJumpChange,

      coms,

      clsx
    }
  }
})
